import { render } from "./SideBarNav.vue?vue&type=template&id=0e71df5b&ts=true"
import script from "./SideBarNav.vue?vue&type=script&lang=ts"
export * from "./SideBarNav.vue?vue&type=script&lang=ts"

import "./SideBarNav.vue?vue&type=style&index=0&id=0e71df5b&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/Momentum/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__